/// <amd-module name="Feed/Legacy/Protocols/Npm/NpmRestApiUrlGeneratorService" />
import { IVssService, Services, VssService } from "VSS/Platform/Context";
import { replaceRouteValues } from "VSS/Platform/Util/Url";

import { getFullyQualifiedFeedId } from "Feed/Legacy//Helpers/FeedNameResolver";
import { generatePackagingServiceRestApiUri, IRestApiRoutes } from "Feed/Legacy/Utils/RestApi";
import { Feed } from "Feed/Legacy/WebApi/VSS.CustomFeed.Contracts";

const NpmArea: string = "npm";

// Used in Download
const Content: IRestApiRoutes = {
    locationId: "75CAA482-CB1E-47CD-9F2C-C048A4B7A43E",
    resource: "content",
    routeTemplate: "packaging/feeds/{feedId}/{area}/packages/{packageName}/versions/{packageVersion}/{resource}"
};

// Used in todo
const UserEndpoint: IRestApiRoutes = {
    locationId: "43F92FEE-B5CA-4A20-90C5-C4E041A0494A",
    resource: "npmUserEndpoint",
    routeTemplate: "{feedId}/{area}" // starts with _packaging and no _apis
};

// Used in todo
const Registry: IRestApiRoutes = {
    locationId: "D9B75B07-F1D9-4A67-AAA6-A4D9E66B3352",
    resource: "registry",
    routeTemplate: "_packaging/{feedId}/{area}/{resource}/{packageName}"
};

export interface INpmRestApiUrlGeneratorService extends IVssService {
    getRegistryUrl(feedId: string, includeProject: boolean, packageName?: string): string;
    getDownloadContentUrl(feed: Feed, packageName: string, packageVersion: string): string;
}

class NpmRestApiUrlGeneratorService extends VssService implements INpmRestApiUrlGeneratorService {
    public getRegistryUrl(feedId: string, includeProject: boolean, packageName?: string): string {
        const path = replaceRouteValues(Registry.routeTemplate, {
            feedId,
            area: NpmArea,
            resource: Registry.resource,
            packageName
        });

        const url = generatePackagingServiceRestApiUri(
            this.pageContext,
            path,
            true /* ignoreApisRelativePath */,
            includeProject
        );
        return this.appendSlashIfMissing(url);
    }

    public getDownloadContentUrl(feed: Feed, packageName: string, packageVersion: string): string {
        const feedId = getFullyQualifiedFeedId(feed);

        const path = replaceRouteValues(Content.routeTemplate, {
            feedId,
            area: NpmArea,
            packageName,
            packageVersion,
            resource: Content.resource
        });

        const includeProject = feed && feed.project != null;
        return generatePackagingServiceRestApiUri(
            this.pageContext,
            path,
            false /* ignoreApisRelativePath */,
            includeProject
        );
    }

    private appendSlashIfMissing(uri: string): string {
        if (uri && uri.length > 0) {
            if (uri.charAt(uri.length - 1) !== "/") {
                return uri + "/";
            }
        }
        return uri;
    }
}

Services.add("INpmRestApiUrlGeneratorService", { serviceFactory: NpmRestApiUrlGeneratorService });
